var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79396 11.1999C8.32729 11.1999 7.86062 11.0199 7.50729 10.6666L3.16063 6.31993C2.96729 6.12659 2.96729 5.8066 3.16063 5.61326C3.35396 5.41993 3.67396 5.41993 3.86729 5.61326L8.21396 9.95993C8.53396 10.2799 9.05396 10.2799 9.37396 9.95993L13.7206 5.61326C13.914 5.41993 14.234 5.41993 14.4273 5.61326C14.6206 5.8066 14.6206 6.12659 14.4273 6.31993L10.0806 10.6666C9.72729 11.0199 9.26063 11.1999 8.79396 11.1999Z",
    fill: "#D9DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.83e64300b3eb8790a874ca4a60c69932.svg";
export { ForwardRef as ReactComponent };